const {
  REACT_APP_AMPLIFY_HOSTED_DOMAIN,
  REACT_APP_AMPLIFY_REGION,
  REACT_APP_AMPLIFY_USER_POOL_ID,
  REACT_APP_AMPLIFY_USER_POOL_WEB_CLIENT_ID,
  REACT_APP_AMPLIFY_REDIRECT_URL,
  REACT_APP_AMPLIFY_COOKIE_DOMAIN,
  REACT_APP_AMPLIFY_COOKIE_SECURE,
} = window;

export const config = {
  Auth: {
    region: REACT_APP_AMPLIFY_REGION,
    userPoolId: REACT_APP_AMPLIFY_USER_POOL_ID,
    userPoolWebClientId: REACT_APP_AMPLIFY_USER_POOL_WEB_CLIENT_ID,
    mandatorySignIn: true,
    oauth: {
      domain: REACT_APP_AMPLIFY_HOSTED_DOMAIN,
      scope: ["email", "openid", "Auth/ReadWrite", "profile"],
      redirectSignIn: REACT_APP_AMPLIFY_REDIRECT_URL,
      redirectSignOut: REACT_APP_AMPLIFY_REDIRECT_URL,
      responseType: "code",
    },
    cookieStorage: {
      domain: REACT_APP_AMPLIFY_COOKIE_DOMAIN,
      path: "/",
      expires: 365,
      sameSite: "strict",
      secure: REACT_APP_AMPLIFY_COOKIE_SECURE,
    },
  },
};

export const logoutUrl = `https://${REACT_APP_AMPLIFY_HOSTED_DOMAIN}/logout?client_id=${REACT_APP_AMPLIFY_USER_POOL_WEB_CLIENT_ID}&logout_uri=${REACT_APP_AMPLIFY_REDIRECT_URL}`;
